import { Navigate } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";
import { can } from "@/admin/api";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, section }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand">
        <Loader2 className="animate-spin text-terracotta" size={32} />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (section && !can(user.role, section)) return <Navigate to="/admin" replace />;
  return children;
}
